<div *ngIf="isVisible"
     [@overlayAnimation]
     class="reading-overlay">

  <div [@modalAnimation]
       class="reading-modal"
       (click)="$event.stopPropagation()">


    <!-- Magnifier SVG Icon -->
    <div class="modal-icon">
      <svg width="80" height="60" viewBox="0 0 80 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="20" width="56" height="11" rx="5.5" fill="#2563EB"/>
        <rect x="2" y="35" width="44" height="8" rx="4" fill="#2563EB" opacity="0.55"/>
        <rect x="2" y="47" width="32" height="7" rx="3.5" fill="#2563EB" opacity="0.3"/>
        <circle cx="63" cy="15" r="15" fill="#F59E0B"/>
        <circle cx="63" cy="15" r="10" fill="#FDE68A"/>
        <circle cx="63" cy="15" r="6" fill="#F59E0B"/>
        <line x1="74" y1="26" x2="80" y2="34" stroke="#92400E" stroke-width="4" stroke-linecap="round"/>
      </svg>
    </div>

    <!-- Title -->
    <h2 class="modal-title">
      Reading <span class="modal-filename">{{ fileName }}</span>
    </h2>

    <!-- Subtitle -->
    <p class="modal-subtitle" [class.success]="!isExtracting && !hasExtractionError" [class.error-text]="hasExtractionError">
      <ng-container *ngIf="isExtracting && secondsRemaining > 0">
        Extracting fields &middot; about
        <span class="countdown">{{ secondsRemaining }}</span>
        seconds left
      </ng-container>
      <ng-container *ngIf="isExtracting && secondsRemaining <= 0">
        Analyzing your document, please wait&hellip;
      </ng-container>
      <ng-container *ngIf="!isExtracting && !hasExtractionError">
        All fields extracted successfully
      </ng-container>
      <ng-container *ngIf="hasExtractionError">
        Failed to analyze document
      </ng-container>
    </p>

    <!-- Fields List -->
    <div class="fields-list">
      <div
        *ngFor="let field of fields; let last = last"
        class="field-row"
        [class.no-border]="last"
        [id]="field.id">

        <span class="field-name" [ngClass]="getFieldNameClass(field.status)">
          {{ field.name }}
        </span>

        <span class="field-status" [ngClass]="getStatusClass(field.status)" [id]="field.statusId">
          {{ getStatusText(field.status) }}
        </span>

      </div>
    </div>

    <!-- Actions shown after extraction completes -->
    <div class="modal-actions" *ngIf="!isExtracting">
      <button pButton type="button"
              label="Continue"
              icon="pi pi-arrow-right"
              iconPos="right"
              (click)="continueWithData()"
              class="p-button-sm continue-btn">
      </button>
      <button pButton type="button"
              label="Cancel"
              (click)="closeModal()"
              class="p-button-sm p-button-text cancel-btn">
      </button>
    </div>

  </div>
</div>